import { render, staticRenderFns } from "./source-company.vue?vue&type=template&id=5a75c5c4"
import script from "./source-company.vue?vue&type=script&lang=js"
export * from "./source-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports